import React from 'react';
import { InfoColumn } from './components/InfoColumn';
import { CredentialsColumn } from './components/CredentialsColumn';
import { ShareContainer } from './components/ShareContainer';
import { LegalLinks } from './components/LegalLinks';
import './Footer.scss';
import { useFetchFooterQuery } from './Footer.service';

const Footer = () => {
  const { data: footerData } = useFetchFooterQuery();

  if (!footerData) {
    return null;
  }

  const { footer, i18n } = footerData;
  const mainOffice = footer.MainOffice;

  return (
    <>
      <div className='l-footer-content'>
        <div className='l-footer-item' />
        <div className='l-footer-item center'>
          <div className='l-footer-content-row'>
            {footer.InfoColumns.map((column, index, array) => {
              if (index === array.length - 1) {
                return (
                  mainOffice && (
                    <CredentialsColumn
                      key={column.Type}
                      info={mainOffice}
                      allOfficesButton={i18n.AllOfficesButton}
                      corporateContactUsPageLink={footer.CorporateContactUsPageLink}
                    />
                  )
                );
              }

              return (
                <InfoColumn key={column.Type} content={column.Content} propertyName={column.Type} />
              );
            })}
          </div>
        </div>
        <div className='l-footer-item right'>
          <svg xmlns='http://www.w3.org/2000/svg' className='right-arc'>
            <path
              d='M 0 20
 A 20 20, 0, 0, 0, 20 0
 L 20 20 Z'
              fill='#11387F'
            ></path>
          </svg>
        </div>
      </div>
      <div className='l-footer-copy-container'>
        <div className='l-footer-copy'>
          <div className='c-copyright'>
            <p className='c-legal-link'>{i18n.Copyright}</p>
          </div>
          <ShareContainer followText={i18n.Follow} />
          <LegalLinks links={footer.Links} />
        </div>
      </div>
    </>
  );
};

export default Footer;
